import React from 'react';
import {Route} from 'react-router-dom';
import {Navigation} from './navigation';

const PublicRouter = (props) => {
			return (
				<div className={'wrapper_app'}>
							{Navigation.mainNavigation.map(route => (
								<Route path={route.path}
									 exact
									 {...props}
									 component={route.main}
									 key={route.path}/>
							))}
				</div>
			);
};

export default PublicRouter;
